module.exports = __webpack_public_path__ + "static/media/MC8.19304468.jpeg";